import "./Badge.scss"

import React, { FunctionComponent, ReactNode } from "react"

interface IBadgeProps {
    theme?: "default" | "red" | "grey" | "green"
    children?: ReactNode
}

const Badge: FunctionComponent<React.PropsWithChildren<IBadgeProps>> = ({
    theme = "default",
    children
}) => {
    return (
        <div className={`badge badge--theme-${theme}`}>
            {children}
        </div>
    )
}

export default Badge
